
function accAdd(num1, num2, notDecimal) {
  const num1Digits = (num1.toString().split('.')[1] || '').length
  const num2Digits = (num2.toString().split('.')[1] || '').length
  const baseNum = Math.pow(10, Math.max(num1Digits, num2Digits))
  return notDecimal ? (Math.round(num1 * baseNum) + Math.round(num2 * baseNum)) / baseNum : changeTwoDecimal((Math.round(num1 * baseNum) + Math.round(num2 * baseNum)) / baseNum)
}

function accMultiply(num1, num2, notDecimal) {
  const num1Digits = (num1.toString().split('.')[1] || '').length
  const num2Digits = (num2.toString().split('.')[1] || '').length
  const baseNum = Math.pow(10, Math.max(num1Digits, num2Digits))
  return notDecimal ? (Math.round(num1 * baseNum) * Math.round(num2 * baseNum)) / baseNum / baseNum : changeTwoDecimal((Math.round(num1 * baseNum) * Math.round(num2 * baseNum)) / baseNum / baseNum)
}

function accDiv(num1, num2, notDecimal) {
  const num1Digits = (num1.toString().split('.')[1] || '').length
  const num2Digits = (num2.toString().split('.')[1] || '').length
  const baseNum = Math.pow(10, Math.max(num1Digits, num2Digits))
  return notDecimal ? (Math.round(num1 * baseNum) / Math.round(num2 * baseNum)) / baseNum / baseNum : changeTwoDecimal((Math.round(num1 * baseNum) / Math.round(num2 * baseNum)) / baseNum / baseNum)
}

function accSubtract(num1, num2, notDecimal) {
  const num1Digits = (num1.toString().split('.')[1] || '').length
  const num2Digits = (num2.toString().split('.')[1] || '').length
  const baseNum = Math.pow(10, Math.max(num1Digits, num2Digits))
  return notDecimal ? (Math.round(num1 * baseNum) - Math.round(num2 * baseNum)) / baseNum : changeTwoDecimal((Math.round(num1 * baseNum) - Math.round(num2 * baseNum)) / baseNum)
}

function changeTwoDecimal(x) {
  var f_x = parseFloat(x)
  if (isNaN(f_x)) {
    return false
  }
  // eslint-disable-next-line no-redeclare
  var f_x = Math.round(x * 100) / 100
  var s_x = f_x.toString()
  var pos_decimal = s_x.indexOf('.')
  if (pos_decimal < 0) {
    pos_decimal = s_x.length
    s_x += '.'
  }
  while (s_x.length <= pos_decimal + 2) {
    s_x += '0'
  }
  return s_x
}

function accDivision(num1, num2, notDecimal) {
  const num1Digits = (num1.toString().split('.')[1] || '').length
  const num2Digits = (num2.toString().split('.')[1] || '').length
  const baseNum = Math.pow(10, Math.max(num1Digits, num2Digits))
  return notDecimal ? (Math.round(num1 * baseNum) / Math.round(num2 * baseNum)) / baseNum / baseNum : changeTwoDecimal((Math.round(num1 * baseNum) / Math.round(num2 * baseNum)) / baseNum / baseNum)
}

export {
  accAdd,
  accMultiply,
  accDiv,
  accSubtract,
  changeTwoDecimal
}



// WEBPACK FOOTER //
// ./src/utils/number.js